export default __webpack_public_path__ + "static/media/iced_mung_bean_drink.628e2aa8.JPG";